<template>
  <div class="yxtbiz-medal-box">    
    <yxtf-image
      class="yxtbiz-medal-box_icon"
      :src="data.activeIcon"
      fit="cover"
    />
    <yxtf-tooltip open-filter :content="title" placement="top">
      <div class="yxtbiz-medal-box_title ellipsis nowrap">{{title}}<template v-if="data.missionCategoryCode==='day_day_up'&&isSelf"> <yxt-tooltip
                :content="$t('pc_biz_lbl_mycontinuedays', [myContinueDays])"
                placement="top"
              >
              <yxt-svg icon-class="question-cirlce-o"
                            width="16px"
                            height="16px"
                            class="ml4 color-gray-7 hand"/>
              </yxt-tooltip></template></div>
    </yxtf-tooltip>
    <yxtf-tooltip open-filter :content="data.description" placement="top">
      <div class="yxtbiz-medal-box_count ellipsis-2 break-word">{{data.description}}</div>
    </yxtf-tooltip>
  </div>
</template>

<script>
// import { CommonUtil } from 'yxt-biz-pc-base';
// const { getLanguage } = CommonUtil
import { getLanguage } from 'yxt-biz-pc/packages/common-util/changeLangs';
export default {
  props: {
    data: {
      type: Object,
      default: ()=>{}
    },
    myContinueDays: {
      type: Number,
      default: 0
    },
    isSelf: {
      // 是否本人查看
      type: Boolean,
      default: false
    }
  },
  computed: {
    title() {
      // medalType: 0-通用勋章， 1-自定义勋章
      return this.data.medalType ? this.data.medalTemplateTitle : this.data.medalTemplateTitle + (getLanguage() === 'en' ? ' LV' : 'LV') + this.data.level;
    }
  }
};
</script>

